import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/public/Navbar";
import Footer from "@/components/public/Footer";
import { track } from "@/lib/api";

export default function PublicLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    let type = "page";
    let ref = null;
    const m = pathname.match(/^\/(galerie|gedichte)\/(.+)$/);
    if (m) {
      type = m[1] === "galerie" ? "artwork" : "poem";
      ref = m[2];
    }
    const t = setTimeout(() => track(pathname, type, ref), 400);
    return () => clearTimeout(t);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#FFF9F2]">
      <Navbar />
      <main className="flex-1 bg-[#FFF9F2] flex flex-col">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
